/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const monitoringIntegrationDetailResponseOutputIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const monitoringIntegrationDetailResponseOutputVersionExclusiveMin = 0;
export const monitoringIntegrationDetailResponseOutputVersionMax = 9007199254740991;

export const monitoringIntegrationDetailResponseOutputTeamOneIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const monitoringIntegrationDetailResponseOutputDefaultCustomerOneIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);

export const monitoringIntegrationDetailResponseOutputPriorityPolicyOnePriorityMax = 4;

export const monitoringIntegrationDetailResponseOutputPriorityPolicyTwoDefaultPriorityMax = 4;

export const monitoringIntegrationDetailResponseOutputLastMessageOneReceivedAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z))$',
);
export const monitoringIntegrationDetailResponseOutputLastMessageOneIncidentIdOneRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const monitoringIntegrationDetailResponseOutputTeamIdOneRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const monitoringIntegrationDetailResponseOutputDefaultCustomerIdOneRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const monitoringIntegrationDetailResponseOutputEndpointMax = 2000;

export const monitoringIntegrationDetailResponseOutputReadinessReasonsMax = 5;

export const monitoringIntegrationDetailResponseOutputReadinessActionsMax = 3;

export const monitoringIntegrationDetailResponseOutputRecentIncidentsItemIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const monitoringIntegrationDetailResponseOutputRecentIncidentsItemReceivedAtRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z))$',
  );
export const monitoringIntegrationDetailResponseOutputRecentIncidentsItemPriorityMax = 4;

export const monitoringIntegrationDetailResponseOutputRecentIncidentsItemVersionExclusiveMin = 0;
export const monitoringIntegrationDetailResponseOutputRecentIncidentsItemVersionMax = 9007199254740991;

export const monitoringIntegrationDetailResponseOutputRecentIncidentsItemCustomerOneIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const monitoringIntegrationDetailResponseOutputRecentIncidentsItemTeamOneIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const monitoringIntegrationDetailResponseOutputRecentIncidentsMax = 5;

export const MonitoringIntegrationDetailResponseOutput = zod.object({
  id: zod.uuid().regex(monitoringIntegrationDetailResponseOutputIdRegExp),
  name: zod.string(),
  provider: zod.enum(['checkly', 'datadog', 'grafana', 'prtg']),
  state: zod.enum(['disabled', 'enabled', 'retired']),
  version: zod
    .int()
    .gt(monitoringIntegrationDetailResponseOutputVersionExclusiveMin)
    .max(monitoringIntegrationDetailResponseOutputVersionMax),
  team: zod.union([
    zod.object({
      id: zod.uuid().regex(monitoringIntegrationDetailResponseOutputTeamOneIdRegExp),
      name: zod.string(),
    }),
    zod.null(),
  ]),
  defaultCustomer: zod.union([
    zod.object({
      id: zod.uuid().regex(monitoringIntegrationDetailResponseOutputDefaultCustomerOneIdRegExp),
      name: zod.string(),
    }),
    zod.null(),
  ]),
  credentialLabel: zod.union([zod.string().min(1), zod.null()]),
  priorityPolicy: zod.union([
    zod.object({
      mode: zod.literal('fixed'),
      priority: zod
        .int()
        .min(1)
        .max(monitoringIntegrationDetailResponseOutputPriorityPolicyOnePriorityMax),
    }),
    zod.object({
      mode: zod.literal('payload'),
      field: zod.string().nullable(),
      defaultPriority: zod
        .int()
        .min(1)
        .max(monitoringIntegrationDetailResponseOutputPriorityPolicyTwoDefaultPriorityMax),
    }),
  ]),
  readiness: zod.enum(['ready', 'not-ready', 'unavailable']),
  lastMessage: zod.union([
    zod.object({
      receivedAt: zod.iso
        .datetime({ offset: true })
        .regex(monitoringIntegrationDetailResponseOutputLastMessageOneReceivedAtRegExp),
      outcome: zod.enum(['created', 'retry', 'grouped', 'ignored', 'refused', 'unavailable']),
      incidentId: zod.union([
        zod
          .uuid()
          .regex(monitoringIntegrationDetailResponseOutputLastMessageOneIncidentIdOneRegExp),
        zod.null(),
      ]),
    }),
    zod.null(),
  ]),
  teamId: zod.union([
    zod.uuid().regex(monitoringIntegrationDetailResponseOutputTeamIdOneRegExp),
    zod.null(),
  ]),
  defaultCustomerId: zod.union([
    zod.uuid().regex(monitoringIntegrationDetailResponseOutputDefaultCustomerIdOneRegExp),
    zod.null(),
  ]),
  endpoint: zod.url().max(monitoringIntegrationDetailResponseOutputEndpointMax),
  readinessReasons: zod
    .array(
      zod.enum([
        'TEAM_REQUIRED',
        'TEAM_INACTIVE',
        'PRIORITY_FIELD_REQUIRED',
        'RETIRED',
        'DEPENDENCY_UNAVAILABLE',
      ]),
    )
    .max(monitoringIntegrationDetailResponseOutputReadinessReasonsMax),
  readinessActions: zod
    .array(zod.enum(['select_team', 'select_priority_field', 'check_again']))
    .max(monitoringIntegrationDetailResponseOutputReadinessActionsMax),
  recentIncidents: zod
    .array(
      zod.object({
        id: zod.uuid().regex(monitoringIntegrationDetailResponseOutputRecentIncidentsItemIdRegExp),
        title: zod.string(),
        receivedAt: zod.iso
          .datetime({ offset: true })
          .regex(monitoringIntegrationDetailResponseOutputRecentIncidentsItemReceivedAtRegExp),
        sourceKind: zod.enum(['monitoring', 'phone']),
        status: zod.enum(['open', 'acknowledged', 'resolved']),
        priority: zod
          .int()
          .min(1)
          .max(monitoringIntegrationDetailResponseOutputRecentIncidentsItemPriorityMax),
        version: zod
          .int()
          .gt(monitoringIntegrationDetailResponseOutputRecentIncidentsItemVersionExclusiveMin)
          .max(monitoringIntegrationDetailResponseOutputRecentIncidentsItemVersionMax),
        customer: zod.union([
          zod.object({
            id: zod
              .uuid()
              .regex(
                monitoringIntegrationDetailResponseOutputRecentIncidentsItemCustomerOneIdRegExp,
              ),
            name: zod.string(),
          }),
          zod.null(),
        ]),
        team: zod.union([
          zod.object({
            id: zod
              .uuid()
              .regex(monitoringIntegrationDetailResponseOutputRecentIncidentsItemTeamOneIdRegExp),
            name: zod.string(),
          }),
          zod.null(),
        ]),
      }),
    )
    .max(monitoringIntegrationDetailResponseOutputRecentIncidentsMax),
});

export type MonitoringIntegrationDetailResponseOutput = zod.input<
  typeof MonitoringIntegrationDetailResponseOutput
>;
export type MonitoringIntegrationDetailResponseOutputOutput = zod.output<
  typeof MonitoringIntegrationDetailResponseOutput
>;
